const hubspotUrl = `https://api.hsforms.com/submissions/v3/integration/submit/${process.env.REACT_APP_HUBSPOT_PORTAL_ID}`;
const accessCatalogFormUrl = `${hubspotUrl}/${process.env.REACT_APP_HUBSPOT_ACCESS_FORM_ID}`;
const eventFormUrl = `${hubspotUrl}/${process.env.REACT_APP_HUBSPOT_EVENT_FORM_ID}`;

export default { accessCatalogFormUrl, eventFormUrl };
